import { MoneyInput } from '@/components';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { useTranslation } from 'react-i18next';
import {
  EinstellungenUpdateForm,
  EinstellungenUpdateFormSchema,
} from '../types';

export function UmsatzProduktivitaetForm({
  form,
  onSubmit,
}: {
  form: EinstellungenUpdateForm;
  onSubmit(data: EinstellungenUpdateFormSchema): void;
}) {
  const { t } = useTranslation();

  return (
    <Form {...form}>
      <form
        id="umsatzplanungEinstellungenForm"
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-2">
        <FormField
          control={form.control}
          name="zielProduktivitaetUmsatz"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t(
                  'domain.controlling.umsatzplanung.einstellungen.inputs.zielProduktivitaetUmsatz.label',
                )}
              </FormLabel>
              <FormControl>
                <MoneyInput
                  isIconVisible={false}
                  unit={t('domain.controlling.umsatzplanung.ziele.€/Std.')}
                  defaultValue={field.value}
                  onBlur={(e) => {
                    field.onChange(e.target.value);
                    form.trigger();
                  }}
                  onInput={(e) => {
                    field.onChange(e.currentTarget.value);
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
